/**
 * Dev-only UI affordances (PoC pages, login prefills, etc.) gated at build time.
 * - Local dev: Quasar sets `import.meta.env.QUASAR_DEV`.
 * - Dev deploys / dev Android: `DEV_BUILD_UI_ENABLED=true` when `BLU_ENV=development`.
 * - Production: always off (no staging/prod opt-in).
 */
export const devBuildUiEnabled =
  !!import.meta.env.QUASAR_DEV ||
  import.meta.env.DEV_BUILD_UI_ENABLED === true ||
  import.meta.env.DEV_BUILD_UI_ENABLED === 'true'

/** Shared demo credentials for dev builds only (never prefilled in production). */
export const devDemoLogin = {
  email: 'demo@bluapps.net',
  password: 'password'
}
